export default {
  empty: () => import("/opt/build/repo/layouts/empty.vue").then(m => m.default || m),
  logged: () => import("/opt/build/repo/layouts/logged.vue").then(m => m.default || m),
  "not-logged": () => import("/opt/build/repo/layouts/notLogged.vue").then(m => m.default || m)
}